import borders from './borders'

export default {
  borders
}
